export function scrollToElm(elm, duration) {
  try {
    var pos = getRelativePos(elm);
    var scrollTarget = pos.top - window.innerHeight / 2 + elm.offsetHeight / 2;
    scrollTo(document.documentElement, scrollTarget, duration); // duration in seconds
  } catch (err) {}
}

function getRelativePos(elm) {
  var cPos = elm.getBoundingClientRect(), // target pos
    pos = {};

  pos.top = cPos.top + window.pageYOffset - 50;
  pos.right = cPos.right;
  pos.bottom = cPos.bottom;
  pos.left = cPos.left;

  return pos;
}

function scrollTo(element, to, duration, onDone) {
  var start = element.scrollTop,
    change = to - start,
    startTime = performance.now(),
    val,
    now,
    elapsed,
    t;

  function animateScroll() {
    now = performance.now();
    elapsed = (now - startTime) / 1000;
    t = elapsed / duration;

    element.scrollTop = start + change * easeInOutQuad(t);

    if (t < 1) window.requestAnimationFrame(animateScroll);
    else onDone && onDone();
  }

  animateScroll();
}

function easeInOutQuad(t) {
  return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
}
